/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleReportManagementState.js'
//import mutations from './moduleUserManagementMutations.js'
import actions from './moduleReportManagementActions.js'
//import getters from './moduleUserManagementGetters.js'
import { getField, updateField } from 'vuex-map-fields';
export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations: {
    SET_USERS (state, users) {
      state.users = users;
    },
    SET_REDEEMS (state, redeems) {
      state.redeems = redeems;
    },
    SET_SPIN (state, spin) {
      state.spin = spin;
    },
    SET_ROULET (state, roulet) {
      state.roulet = roulet;
    },
    SET_ADMIN (state, admin) {
      state.admin = admin;
    },
    updateField,
  },
  actions,
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
  },
}

